import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type CompumaticPunchCompany = {
  id: number
  name: string
}

export type CompumaticPunchLocation = {
  id: number
  name: string
}

export type CompumaticPunchWorker = {
  rawWorkerId: string
  userId: number | null
  displayName: string | null
}

export type CompumaticPunchShift = {
  shiftId: number
  positionName: string
  startsAt: string
  endsAt: string
}

export type CompumaticPunchWorkerShiftAssoc = {
  id: number
  status: string
}

export type CompumaticPunch = {
  id: number
  compumaticCtrId: string
  vendorClockId: string
  punchAt: string
  punchType: string
  status: string
  locationTimezone: string | null
  company: CompumaticPunchCompany | null
  location: CompumaticPunchLocation | null
  worker: CompumaticPunchWorker
  shift: CompumaticPunchShift | null
  workerShiftAssoc: CompumaticPunchWorkerShiftAssoc | null
}

export type ListCompumaticPunchesParams = {
  page: number
  pageSize: number
  companyId?: number
  vendorClockId?: string
  status?: string
}

export type ListCompumaticPunchesResponse = {
  items: CompumaticPunch[]
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export async function listCompumaticPunches(
  params: ListCompumaticPunchesParams
): Promise<ListCompumaticPunchesResponse> {
  const result = await api.get<ListCompumaticPunchesResponse>(
    '/admin/time_clock/compumatic_punches',
    {
      params: {
        page: params.page,
        pageSize: params.pageSize,
        companyId: params.companyId,
        vendorClockId: params.vendorClockId,
        status: params.status,
      },
      paramsSerializer: queryParamSerializer,
    }
  )
  return result.data
}

export async function listRelatedCompumaticPunches(
  punchId: number
): Promise<{ items: CompumaticPunch[] }> {
  const result = await api.get<{ items: CompumaticPunch[] }>(
    `/admin/time_clock/compumatic_punches/${punchId}/related`
  )
  return result.data
}
